module.exports = __webpack_public_path__ + "img/c61fdcc.jpg";